import React from 'react'
import { StyleSheet, css } from 'aphrodite'
import { PropTypes } from 'prop-types'
import UISubtitle from './UISubtitle'
import UIText from './UIText'
import { COLOR_BLACK } from '../../lib/colors'
import LayoutRow from '../Layout/LayoutRow'

const UISelfEmployed = ({
  urssafLink,
  cfeLink,
  formGouvLink,
  title,
  subTitle,
  description1,
  description2,
  description3,
}) => {
  return (
    <div className={css(styles.container)}>
      <UISubtitle label={title} />
      <UIText value={subTitle} dynamicStyle={styles.textStyle} />
      <LayoutRow justifyStart={true}>
        <UIText value={description1} dynamicStyle={styles.textStyle} />
        <a
          className={css(styles.link)}
          href="https://www.autoentrepreneur.urssaf.fr/portail/accueil/creer-mon-auto-entreprise.html"
          target={'_blank'}
          rel="noreferrer"
        >
          {urssafLink}
        </a>
        <UIText value={description2} dynamicStyle={styles.textStyle} />
        <a
          className={css(styles.link)}
          href="https://formalites.entreprises.gouv.fr/"
          target={'_blank'}
          rel="noreferrer"
        >
          {formGouvLink}
        </a>
      </LayoutRow>
      <LayoutRow justifyStart={true}>
        <UIText value={description3} dynamicStyle={styles.textStyle} />
        <a
          className={css(styles.link)}
          href="https://www.insee.fr/fr/information/1972060"
          target={'_blank'}
          rel="noreferrer"
        >
          {cfeLink}
        </a>
      </LayoutRow>
    </div>
  )
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: '40px 20px 40px 0px',
  },
  textStyle: {
    fontSize: 14,
  },
  link: {
    fontSize: 14,
    color: COLOR_BLACK,
    textDecoration: 'underline',
    fontWeight: 'bold',
    margin: '0 5px',
  },
})

UISelfEmployed.propTypes = {
  title: PropTypes.string,
  urssafLink: PropTypes.string,
  subTitle: PropTypes.string,
  cfeLink: PropTypes.string,
  formGouvLink: PropTypes.string,
  description1: PropTypes.string,
  description2: PropTypes.string,
  description3: PropTypes.string,
}

export default UISelfEmployed
